import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'agreement-currency-display',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <div class="mb-3" [ngClass]="{'d-flex justify-content-end align-items-center gap-2': props['inline']}">
            <label class="form-label text-muted" style="font-size: 0.875rem;" [style.margin-bottom]="props['inline'] ? '0' : '0.25rem'">
                <strong>{{ props.label }}</strong>
            </label>
            <p [ngClass]="{'mb-0': props['inline']}">{{displayValue | currency }}<span *ngIf="props['valueSuffix']" class="text-muted fst-italic ms-1" style="font-size: 0.75rem;">{{ props['valueSuffix'] }}</span></p>
        </div>`,
})
export class AgreementCurrencyDisplayComponent extends FieldType<FieldTypeConfig> {
  get displayValue(): number | null {
    const val = this.props.textValue;
    if (val === null || val === undefined || val === '') return null;

    // Strip currency symbols, spaces, commas, etc. — keep digits, decimal point, minus sign
    const cleaned = String(val).replace(/[^0-9.-]/g, '');
    const num = Number(cleaned);
    
    return isNaN(num) ? null : num;
  }
}